import React, { useState, useEffect } from "react";
import * as api from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { HandoverSection, emptyHandover } from "./HandoverSection";

export function ReturnDialog({ item, onClose, onDone, people = [], departments = [] }) {
    const open = !!item;
    const [handover, setHandover] = useState(emptyHandover(null));
    const [photos, setPhotos] = useState([]);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        if (open) { setHandover(emptyHandover(null)); setPhotos([]); }
    }, [open]);

    const submit = async () => {
        setBusy(true);
        try {
            const res = await api.unassignInventoryItem(item.id, {
                return_condition: handover.condition,
                condition_notes: handover.condition_notes,
                return_date: handover.date_undefined ? null : handover.date,
                return_date_undefined: !!handover.date_undefined,
                returned_by: handover.returned_by || null,
            });
            for (const f of photos) {
                await api.uploadInventoryAttachment(item.id, f, `Photo restitution ${handover.date_undefined ? "" : handover.date || ""}`.trim(), { category: "etat_des_lieux", historyId: res.history_id });
            }
            toast.success("Matériel restitué au stock");
            onClose();
            onDone();
        } catch (e) { toast.error(e.response?.data?.detail || "Erreur"); }
        finally { setBusy(false); }
    };

    return (
        <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
            <DialogContent className="max-w-lg">
                <DialogHeader><DialogTitle>Restituer "{item?.asset_tag || item?.name}" au stock</DialogTitle></DialogHeader>
                <div className="max-h-[55vh] overflow-y-auto py-1 pr-1">
                    <HandoverSection value={handover} onChange={setHandover} photos={photos} setPhotos={setPhotos} people={people} departments={departments} mode="restitution" />
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>Annuler</Button>
                    <Button onClick={submit} disabled={busy} data-testid="confirm-return-btn">{busy ? "..." : "Restituer"}</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
